import { render } from "./PayWidget.vue?vue&type=template&id=84816972"
import script from "./PayWidget.vue?vue&type=script&lang=js"
export * from "./PayWidget.vue?vue&type=script&lang=js"

import "./PayWidget.vue?vue&type=style&index=0&id=84816972&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__